import { LookupService } from '../../../services/lookup.service';
import { Component, ElementRef, HostListener, OnDestroy, OnInit, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { ParticipantInformationComponent } from '../../leads/participant-information/participant-information.component';
import { ActivatedRoute, NavigationEnd, Router, RouterModule } from '@angular/router';
import { HorizontalMenuItem, MainMenuItem, MenuItem } from '../../../interfaces/menu.interface';

import { CommonModule } from '@angular/common';
import { SectionsService } from '../../../services/sections.service';
import { BaseComponent } from '../../../shared/utils/base.component';
import { LeadDetailsService } from '../../../services/lead-details.service';
import { LeadCommentsComponent } from '../lead-comments/lead-comments.component';
import { PARTICIPANT_LIMITED_ACCESS_PAGES, STATIC_DATA, STATIC_JSON_DATA_PATH } from '../../../shared/constants/static-data.constants';
import { ListService } from '../../../shared/services/list.service';
import { ButtonComponent, ActionsComponent as PplActionsComponent } from '@ppl/ui';
import { NgZorroModule } from '../../../shared/modules/ng-zorro/ng-zorro.module';
import { NzTabsModule } from 'ng-zorro-antd/tabs';
import { LoggerService } from '../../../shared/services/logger.service';
import { MEMBER_VIEW_PAGE_IDS } from '../../../shared/constants/page.constants';
import { NotificationSMSComponent } from '../../../shared/modals/notification-sms/notification-sms.component';
import { ErrorAlertService } from '../../../shared/services/error-alert.service';
import { TimelineComponent, SideDrawerComponent } from '@ppl/ui';
import { AuthorizeDirective } from '../../../shared/authorization/authorize.directive.';
import { CommunicationLogsComponent } from "../communication-logs/communication-logs.component";
import { environment } from '../../../../environments/environment';
import { ReferralDataService } from '../../../services/referral-data.service';
import { UserService } from '../../../services/user.service';
import { StorageService } from '../../../services/storage.service';
import { ViewportService } from '../../../services/view-port.service';
import { AllowListAuthStore } from '../../../shared/authorization/allow-list-auth.store';

@Component({
  selector: 'ppl-authorization-member-view',
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,
    NgZorroModule,
    NzTabsModule,
    LeadCommentsComponent,
    PplActionsComponent,
    ButtonComponent,
    NotificationSMSComponent,
    TimelineComponent,
    SideDrawerComponent,
    AuthorizeDirective,
    CommunicationLogsComponent
  ],
  providers: [ListService],
  templateUrl: './member-view.component.html',
  styleUrl: './member-view.component.css',
})
export class MemberViewComponent extends BaseComponent implements OnInit, OnDestroy {
  horizontalMenuItemstoDisplay: any;

  /**
   * Tabs an Independent Facilitator may see when opening a participant from the Associations tab
   * — Service Authorizations, To Do List and Provider Services. Lower-cased for comparison; the
   * menu config ids are 'Authorizations', 'TODOList' and 'consumerRates'.
   */
  private static readonly FACILITATOR_VIEW_TABS = ['authorizations', 'todolist', 'consumerrates'];

  /**
   * Set by the Associations tab when an Independent Facilitator opens a participant. Read from
   * router state, the same channel as navigateToTab. Read-only and tab-restricted.
   */
  isFacilitatorView = false;
  selectedMenuItem: any;
  enableComments = false;
  changedCLass = '';
  showMobileTabs = false;
  isMobile = false;
  filledInfo: any;
  id: any;
  applicationData: any[] = [];
  listButton: any[] = [];

  // Catalog of every page-level action button this view can render. The actual set shown
  // is driven by the role's allowedActions config (allowListStore.getAllowedActions(pageId)),
  // not by status or entry. Status-aware gating is the backend's responsibility now.
  private readonly LIST_BUTTON_CATALOG: Record<string, { button_id: string; button_label: string; buttonAction: string; className: string }> = {
    send_sms:          { button_id: 'send_sms',          button_label: 'Send SMS',                buttonAction: 'sendSMS',          className: 'primary-btn-color' },
    send_email:        { button_id: 'send_email',        button_label: 'Send Email',              buttonAction: 'sendEmail',        className: 'primary-btn-color' },
    Resurrect:         { button_id: 'Resurrect',         button_label: 'Resurrect',               buttonAction: 'Resurrect',        className: 'primary-btn-color' },
    assign_to_user:    { button_id: 'assign_to_user',    button_label: 'Assign to User',          buttonAction: 'assign_to_user',   className: 'primary-btn-color' },
    assign_to_me:      { button_id: 'assign_to_me',      button_label: 'Assign to Me',            buttonAction: 'assign_to_me',     className: 'primary-btn-color' },
    Approve:           { button_id: 'Approve',           button_label: 'Approve',                 buttonAction: 'approve',          className: 'primary-btn-color' },
    Deny:              { button_id: 'Deny',              button_label: 'Deny',                    buttonAction: 'Deny',             className: 'primary-btn-color' },
    send_registration: { button_id: 'send_registration', button_label: 'Resend Registration Link', buttonAction: 'send_registration', className: 'primary-btn-color' },
  };

  applicationStatusList: any;
  entry: any;
  sectionDataPath: string = STATIC_JSON_DATA_PATH.LEAD_DETAILS_SECTION_DATA;
  program: any;
  pageId = '';
  tabId = '';
  steps: any;
  showSMSModal: any = '';
  notificationType = '';
  mobileNumber: string[] = [];
  emailId: string[] = [];
  isReadOnly = false;
  isPageRestrictionLoaded = false;
  selectedTabIndex = 0;
  auditHistory: any;
  backLabel = "Back";
  leadData: any;
  isCommunicationLogs = false;
  detailPageBaseUrl = '';
  isExternalEnvironment = false;
  showBackButton = true;
  @ViewChild('mobileMainMenu', { static: false }) mobileMainMenu: any;
  @ViewChildren('tabButton') tabButtons!: QueryList<ElementRef>;
  @ViewChild('tabPanel') tabPanel!: ElementRef;

  // selectedMenuItem: string = '';

  constructor(
    private leadDetailsService: LeadDetailsService,
    private router: Router,
    private sectionsService: SectionsService,
    private loggerService: LoggerService,
    private listService: ListService,
    private referralDataService: ReferralDataService,
    private userService: UserService,
    private storageService: StorageService,
    private viewPort: ViewportService,
    private allowListStore: AllowListAuthStore
  ) {
    super();
  }
  ngOnDestroy(): void {
  }

  ngOnInit(): void {
    this.isExternalEnvironment = environment.isExternal;
    this.isMobile = this.viewPort.isMobileView();

    // Must be read before getMenuItems() so the tab filter can see it.
    this.isFacilitatorView = !!history?.state?.['facilitatorView'];

    // Extract the base URL up to and including '/details'
    const currentUrl = this.router.url.split('?')[0]; // strip query params
    const detailsIndex = currentUrl.indexOf('/details');
    if (detailsIndex !== -1) {
      this.detailPageBaseUrl = currentUrl.substring(0, detailsIndex + '/details'.length);
    } else {
      this.detailPageBaseUrl = currentUrl;
    }

    this.program = this.userService.getSelectedProgram();

    // Hide Back button for external users on their own dashboard with a single role.
    // Show it when they have multiple roles (can go back to pick another)
    // or when they've navigated to another member's details.
    if (this.isExternalEnvironment && this.router.url.startsWith('/home/enrollmentDetails')) {
      const roles = (this.program?.roles || []).filter(Boolean);
      this.showBackButton = roles.length > 1;
    }
    this.entry = this.userService.getLeadEntry();

    this.id = JSON.parse(this.userService.getSelectedLead()!);


    this.pageId = MEMBER_VIEW_PAGE_IDS[this.userService.getFirstSegment()!];
    this.setPageAccess();

    /* this.backLabel = DETAIL_PAGE_BACKBUTTON[this.entry]; */
    /* if(this.entry == STATIC_DATA.REFERRAL){
      this.backLabel = "Back to Referrals";
    }
    else if(this.entry == 'participant'){
      this.backLabel = "Back to Participant Lead";
    }
    else if(this.entry == 'participantEnrollment'){
      this.backLabel = "Back to Participant Enrollment";
    }
    else{
      this.backLabel = "Back to Provider Lead";
    } */
    this.leadDetailsService.getUpdatedLeadData().subscribe((data) => {
      this.leadData = data;
      this.filledInfo =
        data?.responsedata?.infoData;

    })

    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd && this.horizontalMenuItemstoDisplay) {
        const urlSegments = event.urlAfterRedirects.split('/');
        const lastSegment = urlSegments[urlSegments.length - 1]?.split('?')[0];
        const foundTab = this.horizontalMenuItemstoDisplay.find(
          (menuItem: MenuItem) => menuItem.landing_component?.toLowerCase() === lastSegment?.toLowerCase()
        );
        if (foundTab) {
          this.selectedMenuItem = foundTab.menu_id;
          this.updateSelectedTabIndex();
        }
      }
    });
  }

  @HostListener('window:resize')
  onResize() {
    this.isMobile = this.viewPort.isMobileView();
    if (!this.isMobile) {
      this.showMobileTabs = true; // always visible on desktop
    }
  }

  private loadData() {
    try {
      if (this.program.program_code) {
        this.getMenuItems();
      }

      this.leadDetailsService.getUpdatedLeadData().subscribe((data) => {
        const communicationData = data?.responsedata?.communicationData;
        if (communicationData?.contactMethods) {
          this.mobileNumber = communicationData.contactMethods
            .filter((contact: any) => contact.contactMethod === 'mobile')
            .map((contact: any) => contact.value);
          this.emailId = communicationData.contactMethods
            .filter((contact: any) => contact.contactMethod === 'email')
            .map((contact: any) => contact.value);
        }
        this.filledInfo =
          data?.responsedata?.infoData;
        /* this.id = (this.entry == STATIC_DATA.REFERRAL) ? this.filledInfo?.referralId : this.filledInfo?.leadId; */

        if (this.filledInfo) {
          this.applicationData = [
            {
              application_status_lkp: this.filledInfo?.applicationStatus,
              leadId: this.id,
              mobile_number: this.mobileNumber || [],
              email_id: this.emailId || [],
            },
          ];
          this.listService.setApplicationData(this.applicationData);
          // listButton candidates come from the role's allowedActions config; the catalog maps
          // each id to its label/action/className.
          const allowedActions = this.allowListStore.getAllowedActions(this.pageId);
          this.listButton = allowedActions
            .map(id => this.LIST_BUTTON_CATALOG[id])
            .filter((b): b is { button_id: string; button_label: string; buttonAction: string; className: string } => b !== undefined);

          // Status-conditional filter: terminal/completed states only allow a subset of actions
          // regardless of what allowedActions includes. Default (in-flight) status keeps everything.
          const status = this.filledInfo?.applicationStatus?.toLowerCase();
          if (status === 'approved' || status === 'enrollment complete') {
            const allowed = new Set(['send_sms', 'send_email']);
            this.listButton = this.listButton.filter(b => allowed.has(b.button_id));
          } else if (status === 'denied' || status === 'disenrolled') {
            const allowed = new Set(['Resurrect', 'send_sms', 'send_email']);
            this.listButton = this.listButton.filter(b => allowed.has(b.button_id));
          }

          // Entry-conditional override: enrollment flows never offer Approve/Deny/Resurrect.
          // Resend Registration Link is config-gated like every other button — add it under
          // allowedActions for ENROLLED_PARTICIPANT_MEMBER_VIEW / ENROLLED_PROVIDER_MEMBER_VIEW.
          if (this.entry === STATIC_DATA.PARTICIPANT_ENROLLMENT || this.entry === STATIC_DATA.PROVIDER_ENROLLMENT) {
            this.listButton = this.listButton.filter(b => b.button_id !== 'Approve' && b.button_id !== 'Deny' && b.button_id !== 'Resurrect');
          }

          if (this.isReadOnly) {
            this.listButton = [];
          }
        }
      })
    } catch (e) {
      this.loggerService.info('Error in loading data', e);
    }

    this.getLeadData()
  }

  private setPageAccess() {
    const authConfig = this.allowListStore.getConfig();
    if (authConfig && !authConfig.pages[this.pageId]) {
      this.isReadOnly = true;
    }
    this.isPageRestrictionLoaded = true;
    this.loadData();
  }

  getAuthorizedTabs(tabs: any[]) {
    const allowedTabs = this.allowListStore.getAllowedTabs(this.pageId);
    if (allowedTabs.length === 0) return tabs;
    return tabs.filter(c => allowedTabs.some(at => at.toLowerCase() === c.menu_id.toLowerCase()));
  }

  getAuthorizedButtons(buttons: any[]) {
    const allowedButtons = this.allowListStore.getAllowedButtons(this.pageId);
    if (allowedButtons.length === 0) return buttons;
    return buttons.filter(c => allowedButtons.some(ab => ab.toLowerCase() === c.button_id.toLowerCase()));
  }

  getAuthorizedActions(actions: any[]) {
    const allowedActions = this.allowListStore.getAllowedActions(this.pageId);
    if (allowedActions.length === 0) return actions;
    return actions.filter(c => allowedActions.some(aa => aa.toLowerCase() === c.button_id.toLowerCase()));
  }

  async getMenuItems() {
    try {
      if (this.entry) {
        const menu = await this.sectionsService.getJsonConfigurationData(
          STATIC_JSON_DATA_PATH.LEAD_DETAILS_MENU,
          this.entry
        );

        let horizontalMenu = this.getAuthorizedTabs(
          this.filterHorizontalMenuItems(menu.horizontal_menu)
        );
        
        // Gate on the entry (not filledInfo.providerType): filledInfo is loaded asynchronously by
        // getLeadData() which runs after getMenuItems(), so on back-navigation to the provider it's
        // still undefined here and the per-type filtering was being skipped, showing every tab.
        // The logic below only needs enrollmentTypes, which is available synchronously.
         if (this.entry === STATIC_DATA.PROVIDER_ENROLLMENT) {
          const enrollmentTypes = this.sectionsService.getEnrollmentType();
          horizontalMenu = horizontalMenu.map((item: any) => {
            if (item.menu_id === 'invoice') {
              item.display = enrollmentTypes.some((et: string) => ['contractor', 'provider', 'vendor', 'independentFacilitator'].includes(et)) ? 'y' : 'n';
            } else if (item.menu_id === 'serviceCredentials') {
              item.display = enrollmentTypes.some((et: string) => ['contractor', 'provider', 'vendor', 'independentFacilitator'].includes(et)) ? 'y' : 'n';
            } else if (item.menu_id === 'sickTime') {
              item.display = enrollmentTypes.includes('provider') ? 'y' : 'n';
            } else if (item.menu_id === 'timesheet') {
              item.display = enrollmentTypes.includes('provider') ? 'y' : 'n';
            } else if (item.menu_id === 'consumerRates') {
              item.display = enrollmentTypes.includes('employer') ? 'n' : 'y';
            }
            return item;
          });
        }

        // Independent Facilitator viewing a participant from the Associations tab: only these
        // three tabs, and Provider Services read-only (see isFacilitatorView usage in the
        // template). Applied last so it overrides the per-enrollment-type rules above.
        if (this.isFacilitatorView) {
          horizontalMenu = horizontalMenu.filter((item: any) =>
            MemberViewComponent.FACILITATOR_VIEW_TABS.includes(String(item.menu_id).toLowerCase())
          );
        }

        this.horizontalMenuItemstoDisplay = horizontalMenu;
        this.horizontalMenuItemstoDisplay = this.horizontalMenuItemstoDisplay.filter(
          (item: any) => item.display === 'y'
        );
      }
    } catch (e) {
      console.log('error fetching menu items: ', e);
    }

    const navigateToTab = history?.state?.['navigateToTab'];
    const foundTab = this.horizontalMenuItemstoDisplay.find((menuItem: MenuItem) => {
      return menuItem?.menu_id?.toLowerCase() === (navigateToTab?.toLowerCase() || this.horizontalMenuItemstoDisplay[0]?.menu_id?.toLowerCase());
    });

    this.selectedMenuItem = foundTab?.menu_id;
    this.updateSelectedTabIndex();
    await this.getSectionData();


    this.router.navigate([
      `${this.detailPageBaseUrl}/${foundTab.landing_component}`,
    ], { state: history.state });

    /* if (this.entry == 'participant') {
      this.router.navigate([
        `/home/participantLeadsList/leadDetails/${this.horizontalMenuItemstoDisplay[0].landing_component}`,
      ]);
    } else {
      this.router.navigate([
        `/home/providerLeadsList/leadDetails/${this.horizontalMenuItemstoDisplay[0].landing_component}`,
      ]);
    } */
  }

  focusTabPanel() {
    setTimeout(() => {
      this.tabPanel?.nativeElement?.focus();
    }, 0);
  }
  onPanelKeydown(event: KeyboardEvent) {
    if (event.shiftKey && event.key === 'Tab') {
      const focusableElements = this.getFocusableElements(this.tabPanel.nativeElement);
      const current = document.activeElement as HTMLElement;

      const index = focusableElements.findIndex(el => el === current);


      if (index === 0) {
        event.preventDefault();

        const index = this.horizontalMenuItemstoDisplay.findIndex(
          (item: any) => item.menu_id === this.selectedMenuItem
        );

        this.tabButtons.get(index)?.nativeElement?.focus();
      }
    }
  }

  getFocusableElements(container: HTMLElement): HTMLElement[] {
    const focusableSelectors = [
      'a[href]',
      'area[href]',
      'button:not([disabled])',
      'input:not([disabled]):not([type="hidden"])',
      'select:not([disabled])',
      'textarea:not([disabled])',
      '[tabindex]:not([tabindex="-1"])',
      '[contenteditable="true"]'
    ];

    return Array.from(
      container.querySelectorAll(focusableSelectors.join(','))
    )
      .filter((el): el is HTMLElement =>
        el instanceof HTMLElement &&
        !el.hasAttribute('disabled') &&
        !el.getAttribute('aria-hidden')
      );
  }

  async getSectionData() {
    try {
      if (this.entry) {
        this.steps = await this.sectionsService.getJsonConfigurationData(
          this.sectionDataPath,
          this.entry
        );
        this.secData = this.steps['participant_info'];
      }
    } catch (e) {
      console.log('error fetching section data: ', e);
    }
  }

  filterHorizontalMenuItems = (menu: HorizontalMenuItem) => {
    var tabs = menu.filter((menuItem: MenuItem) => {
      return menuItem.display == 'y';
    });

    const allowedTypes = ['provider', 'employer', 'authRepresentative'];
    const enrollmentTypes = this.sectionsService.getEnrollmentType();
    if (enrollmentTypes && enrollmentTypes.length > 0 && !allowedTypes.some(type => enrollmentTypes.includes(type))) {
      tabs = tabs.filter(e => e.menu_id.toLowerCase() !== 'timesheet' && e.menu_id.toLowerCase() !== 'benefits')
    }

    return tabs;
  };

  onMenuSelection = (menuSelected: any) => {
    this.selectedMenuItem = menuSelected.menu_id;
    this.updateSelectedTabIndex();
    this.showMobileTabs = false;
    this.router.navigate([
      `${this.detailPageBaseUrl}/${menuSelected.landing_component}`,
    ], { state: history.state });

    /* if (this.entry == 'participant')
      this.router.navigate([
        `/home/participantLeadsList/leadDetails/${menuSelected.landing_component}`,
      ]);
    else {
      this.router.navigate([
        `/home/providerLeadsList/leadDetails/${menuSelected.landing_component}`,
      ]);
    } */
    /* this.menuService.setSelectedMenu(menuSelected); */
  };

  updateSelectedTabIndex(): void {
    if (!this.horizontalMenuItemstoDisplay || !this.selectedMenuItem) {
      this.selectedTabIndex = 0;
      return;
    }
    for (let i = 0; i < this.horizontalMenuItemstoDisplay.length; i++) {
      if (this.horizontalMenuItemstoDisplay[i]?.menu_id === this.selectedMenuItem) {
        this.selectedTabIndex = i;
        return;
      }
    }
    this.selectedTabIndex = 0;
  }

  onTabIndexChange(index: number): void {
    if (index === this.selectedTabIndex) return;
    const item = this.horizontalMenuItemstoDisplay?.[index];
    if (item) {
      this.onMenuSelection(item);
      this.focusTabPanel();
    }
  }

  toggleMobileTabs(): void {
    this.showMobileTabs = !this.showMobileTabs;
  }


  getUrlForBackButton(): string {
    // Get the current URL
    const currentUrl = this.router.url;
    const urlSegments = currentUrl.split('/'); // Split the URL by '/' and remove the last segment
    urlSegments.splice(-2); // Remove the last two segment
    const newUrl = urlSegments.join('/'); // Join the remaining segments to form the URL
    console.log(newUrl); // Logs the URL without the last segment
    const navigateToTab: string = history?.state['navigateToTab'];
    const navigateLeadId: string = history?.state['leadId'];
    const navigateToproviderType: string = history?.state['providerType'];
    // The Independent Facilitator view opens on the Authorizations tab rather than summary, so it
    // would otherwise miss the "back to provider details" branch below and fall through to the
    // participant enrollment list.
    const isFacilitatorView: boolean = !!history?.state['facilitatorView'];

    if (navigateToTab === 'checklist') {
      urlSegments.splice(-1);
      urlSegments.push('fileTriage');
      return urlSegments.join('/');
    };

    if (navigateToTab === 'documents') {
      urlSegments.splice(-1);
      urlSegments.push('fileUploadNotification');
      return urlSegments.join('/');
    };

    if ((navigateToTab == "summary" || navigateToTab == "associations" || isFacilitatorView) && navigateLeadId) {
      // Coming from manage consumer action — navigate back to provider details
      this.referralDataService.clearReferrralData();
      this.storageService.setSelfEmployerParticipantId(null);
      this.storageService.setShowOtherSignatures(false);
      this.userService.setLeadEntry('providerEnrollment');
      this.sectionsService.setFlow('providerEnrollment');
      this.userService.setSelectedLead(navigateLeadId);
      this.sectionsService.setEnrollmentType(
        JSON.stringify(navigateToproviderType)
      );

      // External members use enrollmentDetails route, not providerEnrollmentList
      if (environment.isExternal) {
        this.userService.setFirstSegment('enrollmentDetails');
        return '/home/enrollmentDetails';
      }

      this.userService.setFirstSegment('providerEnrollmentList');
      return '/home/providerEnrollmentList/details/';
    };

    return newUrl;
  }

  comments() {
    this.enableComments = !this.enableComments;
  }

  getValue(code: string, valueOf: string) {
    let check;
    if (valueOf == 'status') {
      check = this.applicationStatusList;
    } else if (valueOf == 'stage') {
      check = this.applicationStatusList;
    }

    return this.lookupService.getLookupName(check, code);
  }

  // new UI changes

  isTempZActive = false;
  isAuditHistory = false;

  toggleTempZ() {
    this.isTempZActive = !this.isTempZActive; // Toggle the state when the button is clicked
  }

  closeDropdown() {
    this.isTempZActive = false;
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: Event) {
    const target = event.target as HTMLElement;
    if (!target.closest('.dropdown-container')) {
      this.closeDropdown();
    }
  }
  leadId: string | null = null;

  navigateToLeads() {
    const navigateToTab: string = history?.state['navigateToTab'];
    const navigateTo: string = history?.state['navigateTo'];

    if (navigateTo) {
      this.router.navigate([
        navigateTo,
      ]);
      return;
    }

    if (environment.isExternal && !navigateToTab) {
      this.router.navigate([
        `/`,
      ]);
      return;
    }

    const backUrl = this.getUrlForBackButton();
    this.router.navigate([backUrl]).then(() => {
      // Reload component data since MemberViewComponent won't reinitialize on same-parent navigation
      this.id = JSON.parse(this.userService.getSelectedLead()!);
      this.entry = this.userService.getLeadEntry();
      this.program = this.userService.getSelectedProgram();
      this.detailPageBaseUrl = backUrl.endsWith('/') ? backUrl.slice(0, -1) : backUrl;
      if (!this.detailPageBaseUrl.endsWith('/details')) {
        const detailsIndex = this.detailPageBaseUrl.indexOf('/details');
        if (detailsIndex !== -1) {
          this.detailPageBaseUrl = this.detailPageBaseUrl.substring(0, detailsIndex + '/details'.length);
        }
      }
      this.loadData();
    });
  }

  getUpdatedLeadData = (event: boolean) => {
    if (event) {
      this.getLeadData(true);
    }
  };

  getLeadHistory() {

    const entry = this.leadDetailsService.getEntry(this.entry); // this is a special case where the url path parameter is not the same as the UI entry variable
    this.leadDetailsService.getLeadAuditHistory(this.program.program_code, entry,
      this.id).subscribe(data => {
        this.auditHistory = data.responsedata;
        this.isAuditHistory = true;
      });
  }

  communicationLogs() {
    this.isCommunicationLogs = true;
  }
  // sendNotification(type: string) {
  //   const values = type == 'sms' ? this.mobileNumber : this.emailId;
  //   this.notificationType = type == 'sms' ? 'mobile number' : 'email address';
  //   if (!values.length || (values.length && values.some((val) => val === ''))) {
  //     const errorMessage = `Note that the ${this.notificationType} is currently absent in the Contact Details section of profile. Please specify the ${this.notificationType} before continuing.`;
  //     this.errorAlertService.openModal('error', 'Error', errorMessage, '');
  //   } else {
  //     this.showSMSModal = 'sms';
  //   }
  // }

  onHandleCancel(event: any) {
    this.showSMSModal = event;
  }



  getLeadData(isAfterUpdate = false) {
    /* const id = JSON.parse(this.userService.getSelectedLead()!); */
    this.leadDetailsService
      .fetchLeadDetailsApi(
        this.entry,
        this.program.program_code,
        this.id,
        isAfterUpdate
      )
      .subscribe((data: any) => {
        if (this.entry === STATIC_DATA.PROVIDER_ENROLLMENT) {
          this.filledInfo = data?.responsedata?.basicInfo;
        } else {
          this.filledInfo = data?.responsedata?.infoData;
          this.referralDataService.setDemographicData(
            data.responsedata?.infoData
          );
          if (this.entry === STATIC_DATA.PARTICIPANT_ENROLLMENT) {
            this.storageService.setReferralConsumerId(data.responsedata?.infoData?.referralId);
          }
        }
      });
  }
}
